import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';
import { camelCaseToSnakeCase } from '@/core';

type Variables = {
  cars: {
    id: number;
    hoursBetweenTrips: number;
    minHoursInAdvance: number;
    allowSubscription: boolean;
    supportsDelivery: boolean;
    defaultLocationId: string;
    trimId: string;
    licensePlate: string;
    licensePlateState: string;
    gloveboxPin: string;
    useAutomatedPricing: boolean;
    minimumDailyRate: string;
    maximumDailyRate: string;
    dailyRate: string;
  }[];
};
export type UpdateBulkListResponse = {
  data: Car[];
};

export const useBulkListCars = createMutation<
  UpdateBulkListResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/cars/bulk-list`,
      method: 'PUT',
      data: {
        cars: variables.cars.map((car) => ({
          id: car.id,
          hours_between_trips: car.hoursBetweenTrips,
          min_hours_in_advance: car.minHoursInAdvance,
          allow_subscription: car.allowSubscription,
          supports_delivery: car.supportsDelivery,
          default_location_id: car.defaultLocationId,
          trim_id: car.trimId,
          license_plate: car.licensePlate,
          license_plate_state: camelCaseToSnakeCase(car.licensePlateState),
          glovebox_pin: car.gloveboxPin,
          use_automated_pricing: car.useAutomatedPricing,
          minimum_daily_rate: car.minimumDailyRate,
          maximum_daily_rate: car.maximumDailyRate,
          daily_rate: car.dailyRate,
        })),
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.error);
      }),
});
